<template>
  <div>
    <slot
      name="activator"
      :toggle="toggleDisclosure"
      :is-active="isActive"
      :aria-expanded="isActive.toString()"
      :aria-controls="isActive && ariaControls"
    />
    <BaseAccordionAnimation :is-open="isActive">
      <slot name="content" :id="ariaControls" />
    </BaseAccordionAnimation>
  </div>
</template>

<script setup>
import { getUniqueId } from '@/shared/utils/uniqueId.js'
import { ref } from 'vue'
import BaseAccordionAnimation from '@/shared/components/BaseAccordionAnimation.vue'

const props = defineProps({
  initialActiveState: {
    type: Boolean,
    default: false,
  },
})

const ariaControls = `growthmentor-disclosure-${getUniqueId()}`
const isActive = ref(props.initialActiveState)

const toggleDisclosure = () => {
  isActive.value = !isActive.value
}
</script>
